import React from "react";
import { InventoryContextProvider } from "@/contexts/InventoryContext";
import { UserContextProvider } from "@/contexts/UserContext";
import { PrinterContextProvider } from "@/contexts/PrinterContext";
import { IntercomProvider } from "react-use-intercom";
import { ShipmentContextProvider } from "@/contexts/ShipmentContext";
import { ErrorModalContextProvider } from "@/contexts/ErrorModalContext";
import { SubscriptionContextProvider } from "@/contexts/SubscriptionContext";
import { DashboardContextProvider } from "@/contexts/DashboardContext";
import {BuyCostContextProvider} from "@/contexts/BuyCostContext";
import { FbaListingContextProvider } from "@/contexts/FbaListingContext";
import {AnalyticsProvider} from "@/contexts/AnalyticsContext";
import { FbmListingContextProvider } from "@/contexts/FbmListingContext";
import {AsinAnalyticsProvider} from "@/contexts/AsinAnalyticsContext";
import {CategoryAnalyticsProvider} from "@/contexts/CategoryAnalyticsContext";
import { ProfitAndLossAnalyticsProvider } from "@/contexts/ProfitAndLossAnalyticsContext";
import { ProfitOverviewProvider } from "./ProfitOverviewContext";
import { NotificationContextProvider } from "./NotificationContext";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <IntercomProvider appId="s7zia6wi" autoBoot autoBootProps={{ hideDefaultLauncher: true }} initializeDelay={100}>
      <NotificationContextProvider>
        <ErrorModalContextProvider>
          <PrinterContextProvider>
            <AnalyticsProvider>
              <AsinAnalyticsProvider>
                <CategoryAnalyticsProvider>
                  <ProfitAndLossAnalyticsProvider>
                    <ProfitOverviewProvider>
                      <BuyCostContextProvider>
                        <InventoryContextProvider>
                          <ShipmentContextProvider>
                            <FbaListingContextProvider>
                              <FbmListingContextProvider>
                                <SubscriptionContextProvider>
                                  <UserContextProvider>
                                    <DashboardContextProvider>
                                        {children}
                                    </DashboardContextProvider>
                                  </UserContextProvider>
                                </SubscriptionContextProvider>
                              </FbmListingContextProvider>
                            </FbaListingContextProvider>
                          </ShipmentContextProvider>
                        </InventoryContextProvider>
                      </BuyCostContextProvider>
                    </ProfitOverviewProvider>
                  </ProfitAndLossAnalyticsProvider>
                </CategoryAnalyticsProvider>
              </AsinAnalyticsProvider>
            </AnalyticsProvider>
          </PrinterContextProvider>
        </ErrorModalContextProvider>
      </NotificationContextProvider>
    </IntercomProvider>
  );
};